import {GetItemCounts, useInfiniteReferralsCommissionEarned} from "@twigsby/client-data";
import {
    ContentBlock,
    ContentLoader,
    FlexAlign,
    FlexJustify, InfiniteLoadTrigger, ItemRow, ItemRowHeader, RichEmptyState,
    StackHorizontal,
} from "@twigsby/frontend-framework";
import {FormatCurrency, FormatLocaleDateTime, FormatLocaleDateTimeMonthYear} from "@twigsby/helpers";
import React, {useEffect, useRef, useState} from "react";
import {useTranslation} from "@twigsby/frontend-framework";
import {ClipboardImage} from "../../../Components/Images/ClipboardImage";
import {CommissionImage} from "../../../Components/Images/CommissionImage";
import {useSite} from "../../../Providers/SiteInterfaceProvider";

const CommissionEarned = () => {
    const { t } = useTranslation();
    const { currentLocale, updatePageMeta } = useSite();

    const {
        data,
        status,
        error,
        dataUpdatedAt,
        hasNextPage,
        fetchNextPage,
        isFetchingNextPage
    } = useInfiniteReferralsCommissionEarned();

    const [itemCounts, setItemCounts] = useState<any>({ loaded: 0, total: 0 } );

    const commissionEarnedRef = useRef<any>();

    useEffect(() => {
        if(data) {
            setItemCounts(GetItemCounts(data as any));
        }
    }, [dataUpdatedAt, data]);

    useEffect(() => {
        updatePageMeta({
            title: t(`settings.sections.${"Commission Earned"}`)
        });
    }, [currentLocale]);

    return (
        <>
            <StackHorizontal align={FlexAlign.Center} justify={FlexJustify.Between} extraClass={'mb-xs'}>
                <h2 className={'mb-0'}>{t(`settings.sections.${"Commission Earned"}`)}</h2>
            </StackHorizontal>

            <div className={'card commissions-item-rows'} ref={commissionEarnedRef}>

                <ItemRowHeader sticky={true}>
                    <div>{t('settings.referralCommissionEarned.headings.date')}</div>
                    <div>{t('settings.referralCommissionEarned.headings.earned')}</div>
                    <div>{t('settings.referralCommissionEarned.headings.split')}</div>
                    <div>{t('settings.referralCommissionEarned.headings.splitClientShare')}</div>
                    <div>{t('settings.referralCommissionEarned.headings.splitOtherShare')}</div>
                    <div>{t('settings.referralCommissionEarned.headings.datePaid')}</div>
                </ItemRowHeader>

                {status === "loading" ? (
                    <ContentLoader childHeight={'5em'} childCount={10}/>
                ) : status === "error" ? (
                    <ContentBlock error={true} stacked={true} title={error?.name} content={error?.message}/>
                ) : (
                    <>
                        {data.pages.map((group, groupIndex) => {
                            if (group.totalRecords === 0) {
                                return (
                                    <RichEmptyState
                                        title={t('settings.referralCommissionEarned.noData.title')}
                                        description={t('settings.referralCommissionEarned.noData.description')}
                                        media={<CommissionImage />}
                                    />
                                )
                            }

                            return (
                                <>
                                    {group.data.map((commissionEntry, index) => {
                                        return (
                                            <ItemRow
                                                key={`commissionEntry${index}`}
                                                static={true}
                                            >
                                                <div>{commissionEntry.dateEarned ? FormatLocaleDateTimeMonthYear(commissionEntry.dateEarned, currentLocale) : ''}</div>
                                                <div>{FormatCurrency(commissionEntry.earned)}</div>
                                                <div>{commissionEntry.split}</div>
                                                <div>{commissionEntry.splitClientShare}</div>
                                                <div>{commissionEntry.splitOtherShare}</div>
                                                <div>{commissionEntry.datePaid ? FormatLocaleDateTime(commissionEntry.datePaid, currentLocale) : ''}</div>
                                            </ItemRow>
                                        )
                                    })}
                                </>
                            )
                        })}

                        {
                            itemCounts.total > 0 && (
                                <InfiniteLoadTrigger
                                    loaded={itemCounts.loaded}
                                    totalCount={itemCounts.total}
                                    hasNextPage={hasNextPage}
                                    fetchNextPage={fetchNextPage}
                                    isFetchingNextPage={isFetchingNextPage}
                                />
                            )
                        }
                        </>
                        )}
                        </div>
                        </>
                        )
                        }

                            export {CommissionEarned }
